<div class="chat-main-window" role="dialog" aria-modal="true" aria-labelledby="chat-title">
  <div *ngIf="!showLoader; else loaderContainer" class="chat-inner-container">
    <div class="close-button-wrapper">
      <span id="chat-title" class="close-text">
        {{ 'CHAT.HOW_CAN_I_HELP' | translate }}
      </span>

      <button
        class="close-button"
        type="button"
        (click)="goBack()"
        [attr.aria-label]="'COMMON.ACTION.CLOSE' | translate">
        <mat-icon aria-hidden="true">close</mat-icon>
      </button>
    </div>
    <div
      class="chat-messages-container"
      #chatMessagesContainer
      role="log"
      [attr.aria-live]="'polite'"
      [attr.aria-relevant]="'additions'"
      [attr.aria-atomic]="false">
      <ng-container *ngIf="(chatMessages$ | async)?.length; else noMessages">
        <div
          *ngFor="let chatMessage of chatMessages$ | async; index as chatMessageIndex"
          class="chat-message-wrapper"
          [class.to-the-right]="chatMessage.iamAuthor"
          #chatMessage
          role="article"
          [attr.aria-labelledby]="'msg-sr-' + chatMessageIndex">
          <span class="sr-only" [id]="'msg-sr-' + chatMessageIndex">
            {{ chatMessage.authorName }}
            {{ 'CHAT.WROTE' | translate }}: {{ chatMessage.content }}.

            <ng-container *ngIf="chatMessage.attachments?.length">
              {{ 'COMMON.LABEL.ATTACHMENTS' | translate }}:
              <ng-container *ngFor="let attachment of chatMessage.attachments">
                {{ attachment.attachment.fileOriginalName }}
              </ng-container>
            </ng-container>
          </span>

          <div
            *ngIf="!chatMessage.iamAuthor"
            class="author-avatar"
            nz-tooltip
            [nzTooltipTitle]="chatMessage.authorName"
            [attr.aria-hidden]="true">
            <app-cr-avatar [userName]="chatMessage.authorName" [theme]="'THEME-2'"></app-cr-avatar>
          </div>

          <div
            class="chat-message-content"
            aria-hidden="true"
            matTooltip="{{ chatMessage.createdAt | date: 'dd.MM.yyyy HH:mm' }}"
            matTooltipClass="chatTooltip"
            matTooltipPosition="left"
            matTooltipShowDelay="350"
            [ngClass]="chatMessage.iamAuthor ? 'author-messages' : 'interlocutor-messages'"
            [attr.data-cy]="'message-' + chatMessageIndex">
            <div [innerHTML]="chatMessage.content | linebreaks"></div>

            <div *ngIf="chatMessage.attachments?.length" class="message-attachments-wrapper">
              <button
                *ngFor="let attachment of chatMessage.attachments"
                class="message-attachment-item"
                type="button"
                (click)="downloadMessageAttachment(chatMessage.id, attachment.id)"
                [attr.aria-label]="
                  ('CHAT.DOWNLOAD_ATTACHMENT' | translate) + ' ' + attachment.attachment.fileOriginalName
                ">
                <span class="attachment-file-icon" nz-icon nzType="paper-clip" nzTheme="outline"></span>
                <span class="attachment-file-name">{{ attachment.attachment.fileOriginalName }}</span>
              </button>
            </div>
          </div>

          <div
            *ngIf="chatMessage.iamAuthor"
            class="author-avatar"
            nz-tooltip
            [nzTooltipTitle]="chatMessage.authorName"
            [attr.aria-hidden]="true">
            <app-cr-avatar [userName]="chatMessage.authorName" [theme]="'THEME-1'"></app-cr-avatar>
          </div>
        </div>
      </ng-container>
      <ng-template #noMessages>
        <div class="no-messages-wrapper">
          <h2>{{ 'CHAT.NO_MESSAGES_IN_CHAT' | translate }}</h2>
        </div>
      </ng-template>
    </div>
    <div *ngIf="loading$ | async" class="absolute-loader-container" role="status" aria-live="polite">
      <span class="sr-only">
        {{ 'COMMON.LAYOUT.LOADING' | translate }}
      </span>

      <mat-spinner [diameter]="35" [attr.aria-hidden]="true"> </mat-spinner>
    </div>
    <div class="chat-message-input-wrapper standard-form-field">
      <mat-form-field class="chat-message-content-input" appearance="outline">
        <mat-label>{{ 'CHAT.ENTER_YOUR_MESSAGE' | translate }}</mat-label>
        <textarea
          matInput
          #chatMessageInput
          id="chat-message-input-in-modal"
          #autosize="cdkTextareaAutosize"
          cdkTextareaAutosize
          cdkAutosizeMinRows="1"
          cdkAutosizeMaxRows="15"
          autocomplete="off"
          autocapitalize="off"
          [(ngModel)]="newMessageContent"
          (keydown.enter)="$event.preventDefault(); submitMessage($event)"
          maxlength="1500"
          minlength="1"
          [attr.aria-describedby]="'chat-message-error'">
        </textarea>

        <!-- ERROR -->
        <div *ngIf="newMessageContent && !messageContentValid(newMessageContent)" id="chat-message-error">
          {{ 'CHAT.FORBIDDEN_CHARACTERS_USED' | translate }}
        </div>
      </mat-form-field>

      <button
        [disabled]="messageAttachments.length === 0 && (!newMessageContent || !messageContentValid(newMessageContent))"
        mat-icon-button
        color="primary"
        [attr.aria-label]="'CHAT.SEND_MESSAGE' | translate"
        (click)="submitMessage($event)">
        <mat-icon>send</mat-icon>
      </button>

      <nz-badge [nzCount]="messageAttachments?.length">
        <button
          nz-button
          nzType="text"
          nzSize="default"
          nzShape="circle"
          (click)="fileUploadInput.click()"
          [attr.aria-label]="'CHAT.ADD_ATTACHMENT' | translate">
          <span nz-icon nzType="paper-clip" nzTheme="outline"></span>
        </button>
      </nz-badge>
    </div>
  </div>
  <div class="attachments-section-wrapper" *ngIf="attachmentsToAdd$ | async as attachmentsToAdd">
    <div class="attachments-list-label">
      {{ 'COMMON.LABEL.ATTACHMENTS' | translate }}
    </div>
    <div class="attachments-list">
      <div *ngFor="let item of attachmentsToAdd; index as attachmentIndex" class="attachment-asset">
        <ng-container *ngIf="item.uploaded && item.userAsset?.id">
          <span class="blued-text">{{ item.fileOriginalName }}</span>
          <button
            class="remove-attachment-button"
            type="button"
            (click)="removeAsset(item.userAsset)"
            [attr.aria-label]="'COMMON.ACTION.REMOVE' | translate">
            <mat-icon aria-hidden="true">close</mat-icon>
          </button>
        </ng-container>

        <div *ngIf="item.loading" class="loading-wrapper" role="status" aria-live="polite">
          <span class="in-progress-text">
            {{ item.fileOriginalName }}
          </span>

          <span class="sr-only">
            {{ 'COMMON.LAYOUT.LOADING' | translate }}
          </span>

          <mat-spinner [diameter]="25" [attr.aria-hidden]="true"> </mat-spinner>
        </div>

        <ng-container *ngIf="item.error">
          <span class="error-text">
            {{ item.fileOriginalName }}
          </span>
          <mat-icon fontSet="material-icons-outlined" class="error-icon">error</mat-icon>
        </ng-container>
      </div>
    </div>
  </div>
  <input
    id="attachments-input"
    class="file-input-field"
    type="file"
    #fileUploadInput
    multiple
    tabindex="-1"
    (change)="uploadFiles($event)"
    [attr.aria-hidden]="true" />

  <ng-template #loaderContainer>
    <div *ngIf="showLoader" class="loader-container" role="status" aria-live="polite">
      <span class="sr-only">
        {{ 'COMMON.LAYOUT.LOADING' | translate }}
      </span>

      <mat-spinner [diameter]="35" [attr.aria-hidden]="true"> </mat-spinner>
    </div>
  </ng-template>
</div>
